import { Subject } from 'rxjs';

export const ToasterUtil = {
  toast$: new Subject<any>(),
  dispatchData: function(data) {
    this.toast$.next(data);
  },
};
